import { IActivityAction, IBaseAction } from '@models/actions/IBaseAction';
import { getActivityIdFromCompositeId } from '@utils/helpers';
import { AccessibilityActionExecutor } from './AccessibilityActionExecutor';

/** Результат групповой проверки у активити: одна проверка на весь список */
type ActivityGroupResult = { isAccessibly: boolean; errors?: string[] };

export abstract class ActivityBaseActionExecutor extends AccessibilityActionExecutor<ActivityGroupResult> {
    protected _activityId?: string;
    protected _action?: IActivityAction;

    protected storeAction(objId: string, action: IBaseAction) {
        this._activityId = getActivityIdFromCompositeId(objId);
        this._action = action as IActivityAction;
    }

    protected resolveAccessibilityId(objId: string): string {
        return getActivityIdFromCompositeId(objId);
    }

    protected async getService() {
        // Сервис берём динамически: статический импорт замыкал цикл
        // база → ActivityActionsService → фабрика → исполнители → база, и при входе
        // в граф через базовый класс наследники получали undefined вместо предка.
        const { ActivityActionsService } = await import('@services/actions/ActivityActionsService');
        return new ActivityActionsService();
    }

    protected handleGroupAccessibility(
        data: ActivityGroupResult,
        run: (objId: string, action: IBaseAction) => void,
        fail: (errors?: string[]) => void,
        action: IBaseAction,
        objId: string,
    ) {
        if (data.isAccessibly) {
            //успешная проверка групповой Accessibility
            run(objId, action);
        } else {
            fail(data.errors);
        }
    }
}
